import { render, staticRenderFns } from "./SpinningText.vue?vue&type=template&id=24571950&scoped=true"
import script from "./SpinningText.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpinningText.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SpinningText.vue?vue&type=style&index=0&id=24571950&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24571950",
  null
  
)

export default component.exports